import React from 'react';
import sharedAction from 'shared/routes/journal/news-page';
import { setTargetingArguments } from 'shared/actions/globals';
import Layout from '../../../components/Layout';
import LINKS from '../../../constants/navigation';
import NewsPage from './NewsPage';

async function action({ url, ...context }) {
  const { store } = context;
  const data = await sharedAction({ url, ...context });

  if (!data) {
    return null;
  }

  const {
    post,
    title,
    breadcrumbs,
    relatedAdverts,
    targetingArguments,
    ogImage,
    description,
  } = data;

  store.dispatch(setTargetingArguments(targetingArguments));
  const { rubric } = post;
  const showInImage = rubric !== 'aktsii' && rubric !== 'video';
  return {
    chunks: ['news-page'],
    title,
    description,
    ogImage,
    showInImage,
    component: (
      <Layout navLinks={LINKS.JOURNAL} currentRoute={url} hideLocations>
        <NewsPage
          route={url}
          post={post}
          breadcrumbs={breadcrumbs}
          relatedAdverts={relatedAdverts}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/news-page/index.js